import { defineAsyncComponent } from 'vue'
export default {
  admin: defineAsyncComponent(() => import("/usr/src/app/layouts/admin.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/usr/src/app/layouts/default.vue").then(m => m.default || m)),
  login: defineAsyncComponent(() => import("/usr/src/app/layouts/login.vue").then(m => m.default || m)),
  "no-drawer": defineAsyncComponent(() => import("/usr/src/app/layouts/no-drawer.vue").then(m => m.default || m)),
  signup: defineAsyncComponent(() => import("/usr/src/app/layouts/signup.vue").then(m => m.default || m))
}